// extracted by mini-css-extract-plugin
module.exports = {"callingSaveButton":"NButton_callingSaveButton__1QTBL","disableEffect":"NButton_disableEffect__20p1-"};